"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreRefs = void 0;
class FirestoreRefs {
    constructor(firestore) {
        this.inviteCollection = () => this.firestore.collection('invites');
        this.inviteDocument = (id) => this.inviteCollection().doc(id);
        this.bookmarksCollection = () => this.firestore.collection('bookmarks');
        this.bookmarkDocument = (id) => this.bookmarksCollection().doc(id);
        this.assignmentContentCollection = () => this.firestore.collection('assignments');
        this.assignmentContentDocument = (id) => this.assignmentContentCollection().doc(id);
        this.assignmentMetaCollection = () => this.firestore.collection('assignmentMetas');
        this.assignmentMetaDocument = (id) => this.assignmentMetaCollection().doc(id);
        this.assignmentMetaArchiveCollection = () => this.firestore.collection('assignmentMetasArchive');
        this.assignmentMetaArchiveDocument = (id) => this.assignmentMetaArchiveCollection().doc(id);
        this.assignmentSettingCollection = () => this.firestore.collection('assignmentSettings');
        this.assignmentSettings = (id) => this.assignmentSettingCollection().doc(id);
        this.entries = () => this.firestore.collection('entries');
        this.entry = (id) => this.entries().doc(id);
        this.teacherEntries = () => this.firestore.collection('teacherEntries');
        this.teacherEntry = (id) => this.teacherEntries().doc(id);
        this.ratings = () => this.firestore.collection('ratings');
        this.rating = (id) => this.ratings().doc(id);
        this.groupInvites = () => this.firestore.collection('groupInvites');
        this.groupInvite = (id) => this.groupInvites().doc(id);
        this.groups = () => this.firestore.collection('groups');
        this.group = (id) => this.groups().doc(id);
        this.lessonModuleName = 'lessonModules';
        this.lessonModules = (groupId) => this.group(groupId).collection(this.lessonModuleName);
        this.lessonModule = (groupId, id) => this.lessonModules(groupId).doc(id);
        this.lessonModulesCollectionGroup = () => this.firestore.collectionGroup(this.lessonModuleName);
        this.studentActivityName = 'studentActivity';
        this.studentActivities = (groupId) => this.group(groupId).collection(this.studentActivityName);
        this.studentActivity = (groupId, id) => this.studentActivities(groupId).doc(id);
        this.studentActivityCollectionGroup = () => this.firestore.collectionGroup(this.studentActivityName);
        this.sessions = () => this.firestore.collection('sessions');
        this.session = (id) => this.sessions().doc(id);
        this.firestore = firestore;
    }
}
exports.FirestoreRefs = FirestoreRefs;
//# sourceMappingURL=FirestoreRefs.js.map